import { createIcon } from '@chakra-ui/react';

export const FacebookIcon = createIcon({
  displayName: 'FacebookIcon',
  viewBox: '0 0 17 16',
  path: [
    <path
      key="1"
      d="M7.63001 5.958V6.876H6.95801V7.998H7.63001V11.3333H9.01134V7.998H9.93801C9.93801 7.998 10.0253 7.46 10.0673 6.87133H9.01667V6.10466C9.01667 5.98933 9.16734 5.83533 9.31667 5.83533H10.0687V4.66666H9.04534C7.59601 4.66666 7.63001 5.79 7.63001 5.958Z"
      fill="white"
    />,
    <path
      key="2"
      d="M8.50001 13.3333C9.9145 13.3333 11.2711 12.7714 12.2712 11.7712C13.2714 10.771 13.8333 9.41449 13.8333 8C13.8333 6.58551 13.2714 5.22896 12.2712 4.22877C11.2711 3.22857 9.9145 2.66667 8.50001 2.66667C7.08552 2.66667 5.72897 3.22857 4.72877 4.22877C3.72858 5.22896 3.16668 6.58551 3.16668 8C3.16668 9.41449 3.72858 10.771 4.72877 11.7712C5.72897 12.7714 7.08552 13.3333 8.50001 13.3333ZM8.50001 14.6667C4.81801 14.6667 1.83334 11.682 1.83334 8C1.83334 4.318 4.81801 1.33334 8.50001 1.33334C12.182 1.33334 15.1667 4.318 15.1667 8C15.1667 11.682 12.182 14.6667 8.50001 14.6667Z"
      fill="white"
    />
  ]
});
